import { useConnect } from '@zealforchange/redux-encapsulation'
import { State } from '@reducers/modules/common'
import * as actions from '@actions/common'

export function useCommonDispatch() {
  return useConnect<{ Common: State }, { Common: State }, typeof actions>((state: { Common: State }) => {
    return { Common: state.Common }
  }, actions) as [{ Common: State }, typeof actions]
}
